import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { FlightModalAPI } from "../API/FlightModalAPI";

const FlightModelContext = createContext(null);

export function FlightModelProvider({ children }) {
  // const [selectedFlightModel, setSelectedFlightModelState] = useState(
  //   localStorage.getItem("flight_model") || null,
  // );
   const [selectedFlightModel, setSelectedFlightModelState] = useState(null);
  const [flightModels, setFlightModels] = useState([]);
  const [loading, setLoading] = useState(false);

  // const setSelectedFlightModel = useCallback((model) => {
  //   setSelectedFlightModelState(model ?? null);
  //   if (model) localStorage.setItem("flight_model", model);
  //   else localStorage.removeItem("flight_model");
  // }, []);
  const setSelectedFlightModel = useCallback((model) => {
    setSelectedFlightModelState(model ?? null);
  }, []);


  const refreshFlightModels = useCallback(async () => {
    const isLoggedIn = !!localStorage.getItem("SWAAccessToken");
    if (!isLoggedIn) {
      setFlightModels([]);
      setSelectedFlightModel(null);
      return { selectedFlightModel: null, flightModels: [] };
    }

    setLoading(true);
    try {
      const res = await FlightModalAPI.getFlightModals();
      if (res?.data?.status !== true) {
        return { selectedFlightModel, flightModels };
      }

      const models = res?.data?.flight_models || [];
      const selected = res?.data?.selected_flight_model || null;

      setFlightModels(models);
      if (selected) setSelectedFlightModel(selected);

      return { selectedFlightModel: selected, flightModels: models };
    } finally {
      setLoading(false);
    }
  }, [flightModels, selectedFlightModel, setSelectedFlightModel]);

  const value = useMemo(
    () => ({
      loading,
      selectedFlightModel,
      setSelectedFlightModel,
      flightModels,
      refreshFlightModels,
    }),
    [flightModels, loading, refreshFlightModels, selectedFlightModel, setSelectedFlightModel],
  );

  return <FlightModelContext.Provider value={value}>{children}</FlightModelContext.Provider>;
}

export function useFlightModel() {
  const ctx = useContext(FlightModelContext);
  if (!ctx) {
    throw new Error("useFlightModel must be used within a FlightModelProvider");
  }
  return ctx;
}

